import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-8 border-2 rounded-lg border-red-500 px-4 py-4"
}
const _hoisted_2 = { class: "flex mb-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-lg font-bold ml-2 text-red-500" }, "Warning", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, " Participating in a Liquidity Bootstrapping Pool on Beethoven X is a high-risk endeavor. The value of the tokens that you receive could go to 0. Beethoven X is not liable for any losses incurred by using our platform. Please be careful and do your own research before participating in any event. ", -1)
const _hoisted_5 = { class: "flex items-end mt-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://docs.embr.io/balancer-v2-1/lbps-for-token-launches",
    target: "_blank",
    class: "text-green-500"
  }, " Read More ")
], -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("I understand")

import { ref } from 'vue';
import BalIcon from '@/components/_global/BalIcon/BalIcon.vue';
import BalBtn from '@/components/_global/BalBtn/BalBtn.vue';


export default _defineComponent({
  setup(__props) {

const hidden = ref(false);

return (_ctx: any,_cache: any) => {
  return (!hidden.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(BalIcon, {
            name: "alert-triangle",
            size: "lg",
            class: "text-red-500"
          }),
          _hoisted_3
        ]),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(BalBtn, {
            size: "sm",
            color: "red",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (hidden.value = true))
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})